(() => {
  'use strict';
  const config = window.BasicShopifyConfig;
  if (!config) return;
  const supported = new Set(['fr','de','en']);
  const lang = config.locale.slice(0,2);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const localKey = value => String(value || '').replace(/^\/+/, '').replace(/^(?:de|en)\//, '');
  const resolve = value => {
    // HTML snippets contain escaped query separators; URLSearchParams needs
    // the decoded value or a second filter becomes the key "amp;q".
    if(typeof value==='string') value=value.replace(/&amp;/g,'&');
    if (!value || value.startsWith('#') || value.startsWith('?')) return value;
    let url;
    try { url = new URL(value, location.origin + root); } catch { return value; }
    if (url.origin !== location.origin) return value;
    let path = localKey(url.pathname);
    if (root !== '/') path = localKey(url.pathname.startsWith(root) ? url.pathname.slice(root.length) : url.pathname);
    if (config.routes.local[path]) {
      const target = new URL(config.routes.local[path], location.origin);
      url.searchParams.forEach((value,key)=>target.searchParams.set(key,value));
      const basicSeoCategoryHandles = {deodorants:'deodorants',visage:'visage',corps:'corps',cheveux:'cheveux',levres:'baume-a-levres','baume-a-levres':'baume-a-levres',huiles:'huiles'};
      const basicSeoCategoryHandle = basicSeoCategoryHandles[target.searchParams.get('categorie')];
      if (basicSeoCategoryHandle && /\/collections\/all\/?$/.test(target.pathname)) {
        target.pathname = target.pathname.replace(/\/collections\/all\/?$/, '/collections/' + basicSeoCategoryHandle);
        target.searchParams.delete('categorie');
      }
      target.hash=url.hash;
      return target.pathname + target.search + target.hash;
    }
    if (config.assets[path]) return config.assets[path];
    return value;
  };
  let strings = {};
    function dynamicTranslation(value) {
    if (lang === 'fr') return value;
    if (Object.prototype.hasOwnProperty.call(strings, value)) return strings[value];
    const name = part => strings[part] || part;
    const plan = /^(Chaque mois|Tous les [23] mois) · (−\d+ %)$/.exec(value);
    if (plan) return `${name(plan[1])} · ${plan[2]}`;
    const quantity = /^(\d+) (sélections?|flacons?|recharges?|articles?)$/.exec(value);
    if (quantity) {
      const number = Number(quantity[1]);
      const unit = quantity[2].replace(/s$/, '');
      const words = lang === 'de'
        ? {sélection: 'Auswahl', flacon: 'Flakon', recharge: 'Nachfüllung', article: 'Artikel'}
        : {sélection: 'selection', flacon: 'bottle', recharge: 'refill', article: 'item'};
      const translated = words[unit];
      const plural = lang === 'de'
        ? {sélection: 'Auswahlen', flacon: 'Flakons', recharge: 'Nachfüllungen', article: 'Artikel'}[unit]
        : `${translated}s`;
      return `${number} ${number === 1 ? translated : plural}`;
    }
    const question = /^Question (\d+) sur (\d+)$/.exec(value);
    if (question) return lang === 'de' ? `Frage ${question[1]} von ${question[2]}` : `Question ${question[1]} of ${question[2]}`;
    const diagnosticStart = /^Ton point de départ · (.+)$/.exec(value);
    if (diagnosticStart) return `${lang === 'de' ? 'Ihr Ausgangspunkt' : 'Your starting point'} · ${name(diagnosticStart[1])}`;
    const viewKit = /^Voir le kit (.+)$/.exec(value);
    if (viewKit) return lang === 'de' ? `Set ${name(viewKit[1])} ansehen` : `View the ${name(viewKit[1])} kit`;
    const serumButton = /^Ajouter mes (\d+) sérums$/.exec(value);
    if (serumButton) return lang === 'de' ? `Meine ${serumButton[1]} Seren hinzufügen` : `Add my ${serumButton[1]} serums`;
    const donation = /^CHF ([\d.,’\s–−-]+) reversés à OSE après ton achat$/.exec(value);
    if (donation) return lang === 'de' ? `CHF ${donation[1]} gehen nach Ihrem Kauf an OSE` : `CHF ${donation[1]} donated to OSE after your purchase`;
    const goalLeft = /^Encore (CHF [\d.,’\s–−-]+) pour atteindre ce palier\.$/.exec(value);
    if (goalLeft) return lang === 'de' ? `Noch ${goalLeft[1]} bis zu diesem Ziel.` : `${goalLeft[1]} to reach this milestone.`;
    const goalNext = /^(CHF [\d.,’\s–−-]+) générés sur CHF 5’000\. Prochain objectif : (CHF [\d.,’\s–−-]+)\.$/.exec(value);
    if (goalNext) return lang === 'de' ? `${goalNext[1]} von CHF 5’000 gesammelt. Nächstes Ziel: ${goalNext[2]}.` : `${goalNext[1]} raised toward CHF 5’000. Next goal: ${goalNext[2]}.`;
    const goalFinal = /^(CHF [\d.,’\s–−-]+) générés\. Objectif final de CHF 5’000 atteint\.$/.exec(value);
    if (goalFinal) return lang === 'de' ? `${goalFinal[1]} gesammelt. Das letzte Ziel von CHF 5’000 ist erreicht.` : `${goalFinal[1]} raised. The final CHF 5’000 goal has been reached.`;
    const pool = /^Cagnotte : (CHF [\d.,’\s–−-]+)$/.exec(value);
    if (pool) return lang === 'de' ? `Spendenstand: ${pool[1]}` : `Donation total: ${pool[1]}`;
    const selectedRefill = /^(\d+) recharges? Le Rose(?: \+ 1 applicateur (.+))?$/.exec(value);
    if (selectedRefill) {
      const count = Number(selectedRefill[1]);
      const product = lang === 'de' ? `${count} Le Rose-${count === 1 ? 'Nachfüllung' : 'Nachfüllungen'}` : `${count} Le Rose ${count === 1 ? 'refill' : 'refills'}`;
      return selectedRefill[2] ? `${product} + 1 ${lang === 'de' ? 'Applikator' : 'applicator'} ${selectedRefill[2]}` : product;
    }
    const updated = /^Quantité mise à jour pour (.+)\.$/.exec(value);
    if (updated) return lang === 'de' ? `Menge für ${name(updated[1])} aktualisiert.` : `Quantity updated for ${name(updated[1])}.`;
    const removed = /^(.+) retiré du panier\.$/.exec(value);
    if (removed) return lang === 'de' ? `${name(removed[1])} aus dem Warenkorb entfernt.` : `${name(removed[1])} removed from cart.`;
    const review = /^Revoir (.+)$/.exec(value);
    if (review) return lang === 'de' ? `${name(review[1])} erneut ansehen` : `Review ${name(review[1])}`;
    const selectionCount = /^Nombre de sélections de (.+)$/.exec(value);
    if (selectionCount) return lang === 'de' ? `Anzahl Auswahlen für ${name(selectionCount[1])}` : `Number of selections for ${name(selectionCount[1])}`;
    const removeSelection = /^Retirer une sélection de (.+)$/.exec(value);
    if (removeSelection) return lang === 'de' ? `Eine Auswahl von ${name(removeSelection[1])} entfernen` : `Remove one selection of ${name(removeSelection[1])}`;
    const addSelection = /^Ajouter une sélection de (.+)$/.exec(value);
    if (addSelection) return lang === 'de' ? `Eine Auswahl von ${name(addSelection[1])} hinzufügen` : `Add one selection of ${name(addSelection[1])}`;
    const removeCart = /^Retirer (.+) du panier$/.exec(value);
    if (removeCart) return lang === 'de' ? `${name(removeCart[1])} aus dem Warenkorb entfernen` : `Remove ${name(removeCart[1])} from cart`;
    const saved = /^(CHF [\d.,’\s–−-]+) économisés$/.exec(value);
    if (saved) return lang === 'de' ? `${saved[1]} gespart` : `${saved[1]} saved`;
    const refillDetail = /^(\d+) recharges? · 41 g( net)?$/.exec(value);
    if (refillDetail) {
      const count = Number(refillDetail[1]);
      return lang === 'de' ? `${count} ${count === 1 ? 'Nachfüllung' : 'Nachfüllungen'} · 41 g${refillDetail[2] ? ' netto' : ''}` : `${count} ${count === 1 ? 'refill' : 'refills'} · 41 g${refillDetail[2] ? ' net' : ''}`;
    }
    const shipping = /^Encore (CHF [\d.,’\s–−-]+) (?:pour|avant) la livraison offerte\.?$/.exec(value);
    if (shipping) return lang === 'de' ? `Noch ${shipping[1]} bis zum kostenlosen Versand.` : `${shipping[1]} away from free shipping.`;
    const result = /^Résultats pour « (.*) »$/.exec(value);
    if (result) return lang === 'de' ? `Ergebnisse für «${result[1]}»` : `Results for “${result[1]}”`;
    const count = /^(\d+) produits?(?: sur (\d+))?$/.exec(value);
    if (count) {
      const number = Number(count[1]);
      const noun = lang === 'de' ? (number === 1 ? 'Produkt' : 'Produkte') : (number === 1 ? 'product' : 'products');
      return `${number} ${noun}${count[2] ? (lang === 'de' ? ` von ${count[2]}` : ` of ${count[2]}`) : ''}`;
    }
    const summary = /^(\d+) produits? et (\d+) pages? à explorer\.$/.exec(value);
    if (summary) {
      const products = Number(summary[1]), pages = Number(summary[2]);
      const productNoun = lang === 'de' ? (products === 1 ? 'Produkt' : 'Produkte') : (products === 1 ? 'product' : 'products');
      const pageNoun = lang === 'de' ? (pages === 1 ? 'Seite' : 'Seiten') : (pages === 1 ? 'page' : 'pages');
      return lang === 'de' ? `${products} ${productNoun} und ${pages} ${pageNoun} entdecken.` : `Explore ${products} ${productNoun} and ${pages} ${pageNoun}.`;
    }
    const discovery = /^(\d+) (produits?|pages?) à (découvrir|explorer)\.$/.exec(value);
    if (discovery) {
      const singular = Number(discovery[1]) === 1;
      const noun = discovery[2].startsWith('produit') ? (lang === 'de' ? (singular ? 'Produkt' : 'Produkte') : (singular ? 'product' : 'products')) : (lang === 'de' ? (singular ? 'Seite' : 'Seiten') : (singular ? 'page' : 'pages'));
      return lang === 'de' ? `${discovery[1]} ${noun} entdecken.` : `Explore ${discovery[1]} ${noun}.`;
    }
    return value;
  }

  function translateText(node) {
    if (lang === 'fr' || !node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (!parent || parent.closest('script,style,svg,noscript,[translate="no"]')) return;
    const match = /^(\s*)(.*?)(\s*)$/s.exec(node.nodeValue);
    if (!match || !match[2]) return;
    const next = dynamicTranslation(match[2]);
    if (next !== match[2]) node.nodeValue = match[1] + next + match[3];
  }

  function translateAttributes(element) {
    if (lang === 'fr' || element.closest('[translate="no"]')) return;
    for (const name of ['alt', 'aria-label', 'placeholder', 'title', 'data-gallery-alt', 'data-alt', 'data-preview-caption']) {
      const value = element.getAttribute(name);
      if (!value) continue;
      const next = dynamicTranslation(value);
      if (next !== value) element.setAttribute(name, next);
    }
  }


  window.basicLocale = {lang, root:location.origin+root, url:resolve, t:dynamicTranslation};
  config.resolve = resolve;
  config.transformHTML = markup => String(markup).replace(/\b(href|src|action|formaction|poster|data-[\w-]+)=(['"])(.*?)\2/g,(full,attr,quote,value)=>attr+'='+quote+resolve(value).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')+quote);
  const process = node => {
    if (node.nodeType === 3) { translateText(node); return; }
    if (node.nodeType !== 1) return;
    for (const attr of ['href','src','action','formaction','poster','data-product-image','data-image','data-photo','data-rose-photo']) {
      const value=node.getAttribute(attr);
      if (value) { const resolved=resolve(value); if(resolved!==value) node.setAttribute(attr,resolved); }
    }
    translateAttributes(node);
    for (const child of node.childNodes) process(child);
  };
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => originalFetch(typeof input==='string' ? resolve(input) : input, init);
  const init = () => {
    strings = window.basicTranslations || {};
    process(document.body);
    new MutationObserver(records => records.forEach(record => {
      if(record.type==='childList') record.addedNodes.forEach(process);
      else process(record.target);
    })).observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['href','src','action','formaction','poster','data-product-image','data-image','data-photo','data-rose-photo','alt','aria-label','placeholder','title']});
    for (const select of document.querySelectorAll('#site-language, #site-language-mobile')) {
      select.value=lang;
      select.addEventListener('change',()=>{
        if(!supported.has(select.value)) return;
        const form=document.createElement('form'); form.method='post'; form.action=root+'localization';
        const values={form_type:'localization',utf8:'✓',_method:'put',language_code:select.value,return_to:location.pathname+location.search+location.hash};
        Object.entries(values).forEach(([name,value])=>{const field=document.createElement('input');field.type='hidden';field.name=name;field.value=value;form.append(field);});
        document.body.append(form);form.submit();
      });
    }
  };
  // Deferred scripts execute while readyState is interactive. Wait for all
  // page dictionaries before translating dynamic content and observing it.
  if(document.readyState!=='complete') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
